import { render, staticRenderFns } from "./instancePermissionCard.vue?vue&type=template&id=11e7a646&lang=pug"
import script from "./instancePermissionCard.vue?vue&type=script&lang=js"
export * from "./instancePermissionCard.vue?vue&type=script&lang=js"
import style0 from "./instancePermissionCard.vue?vue&type=style&index=0&id=11e7a646&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports